module.exports = __webpack_public_path__ + "assets/img/PC2.1961ca12.jpg";